import type { Meta } from "types/backend/models/cms/meta.entity";

export function hasHttp(str: string) {
  return str.indexOf("http://") > -1 || str.indexOf("https://") > -1;
}

export enum MetaType {
  default = "default",
  alternate = "alternate",
  custom = "custom",
}

export function makeMeta(title: string, description?: string) {
  return [
    {
      metaType: MetaType.default,
      type: "Page",
      title,
      description,
      twitter: true,
      og: true,
    },
  ] as Meta[];
}
